(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455,4006],{

/***/ 9254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ contact_us; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(1608);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(1555);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./styles/contact.module.scss
var contact_module = __webpack_require__(451);
var contact_module_default = /*#__PURE__*/__webpack_require__.n(contact_module);
// EXTERNAL MODULE: ./src/components/Shared/Form.js
var Form = __webpack_require__(472);
// EXTERNAL MODULE: ./src/components/Layout/Footer.js + 5 modules
var Footer = __webpack_require__(296);
// EXTERNAL MODULE: ./src/components/Shared/Next-seo.js
var Next_seo = __webpack_require__(6543);
// EXTERNAL MODULE: ./src/components/Shared/BreadCrumbs.js
var BreadCrumbs = __webpack_require__(5467);
// EXTERNAL MODULE: ./src/components/Home/ContactNumbers/styles/style.module.scss
var style_module = __webpack_require__(9256);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./src/components/Home/ContactNumbers/assets/human.svg
/* harmony default export */ var human = ({"src":"/_next/static/media/human.f58bcbff.svg","height":123,"width":122});
;// CONCATENATED MODULE: ./src/components/Home/ContactNumbers/assets/whatsapp.svg
/* harmony default export */ var whatsapp = ({"src":"/_next/static/media/whatsapp.a343923c.svg","height":200,"width":200});
;// CONCATENATED MODULE: ./src/components/Home/ContactNumbers/assets/call.svg
/* harmony default export */ var call = ({"src":"/_next/static/media/call.888f177a.svg","height":200,"width":200});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/whatsapp.mjs
var utils_whatsapp = __webpack_require__(735);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/Home/ContactNumbers/index.js














var ContactNumbers = function ContactNumbers(_ref) {
  var _initData$siteInfo;

  var initData = _ref.initData;

  var _useRouter = (0,router.useRouter)(),
      locale = _useRouter.locale; // const userPhones = [
  //     {
  //         name: {
  //             en: "Mohamed Abdelrahman Ahmed Mohamed",
  //             ar: "محمد عبد الرحمن احمد محمد"
  //         },
  //         number: "01000014330",
  //     },
  //     {
  //         name: {
  //             en: "Mohamed",
  //             ar: "محمد"
  //         },
  //         number: "01000014330",
  //     },
  //     {
  //         name: {
  //             en: "Mohamed",
  //             ar: "محمد"
  //         },
  //         number: "01000014330",
  //     },
  // ]


  var userPhones = initData === null || initData === void 0 ? void 0 : (_initData$siteInfo = initData.siteInfo) === null || _initData$siteInfo === void 0 ? void 0 : _initData$siteInfo.userPhones;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (style_module_default())["contact-nums"],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      className: "pb-5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "fw-bold mb-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
          id: "contact-nums"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        className: "contacts-container gy-4",
        children: userPhones === null || userPhones === void 0 ? void 0 : userPhones.map(function (phone, index) {
          var _phone$name;

          return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
            xxl: 4,
            xl: 4,
            lg: 4,
            md: 6,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "card-item",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "contact-icon",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: human,
                  width: 30,
                  height: 30,
                  alt: "contact-icon"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "contact-name",
                children: phone === null || phone === void 0 ? void 0 : (_phone$name = phone.name) === null || _phone$name === void 0 ? void 0 : _phone$name[locale]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "contact-nums",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: (0,utils_whatsapp/* buildWhatsAppUrl */.H)(phone.number),
                  legacyBehavior: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      className: "whatsapp",
                      "aria-label": "whatsapp-link",
                      href: "!#",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: whatsapp,
                        width: 30,
                        height: 30,
                        alt: "whatsapp link"
                      })
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: "tel:".concat(phone.number),
                  legacyBehavior: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      className: "call",
                      "aria-label": "call-link",
                      href: "!#",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: call,
                        width: 30,
                        height: 30,
                        alt: "call-link"
                      })
                    })
                  })
                })]
              })]
            }, index)
          }, index);
        })
      })]
    })
  });
};

/* harmony default export */ var Home_ContactNumbers = (ContactNumbers);
;// CONCATENATED MODULE: ./pages/contact-us.js













var ContactPage = function ContactPage(_ref) {
  var _seoData$title, _seoData$title2, _seoData$description, _seoData$keywords, _initData$siteInfo$ma, _initData$siteInfo;

  var contactData = _ref.contactData,
      initData = _ref.initData,
      error = _ref.error,
      seoData = _ref.seoData;

  var _useIntl = (0,useIntl/* default */.Z)(),
      locale = _useIntl.locale,
      formatMessage = _useIntl.formatMessage;

  error && console.log(JSON.parse(error));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(seoData === null || seoData === void 0 ? void 0 : (_seoData$title = seoData.title) === null || _seoData$title === void 0 ? void 0 : _seoData$title[locale]) && /*#__PURE__*/(0,jsx_runtime.jsx)(Next_seo["default"], {
      title: seoData === null || seoData === void 0 ? void 0 : (_seoData$title2 = seoData.title) === null || _seoData$title2 === void 0 ? void 0 : _seoData$title2[locale],
      description: seoData === null || seoData === void 0 ? void 0 : (_seoData$description = seoData.description) === null || _seoData$description === void 0 ? void 0 : _seoData$description[locale],
      keywords: seoData === null || seoData === void 0 ? void 0 : (_seoData$keywords = seoData.keywords) === null || _seoData$keywords === void 0 ? void 0 : _seoData$keywords[locale]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "contact-page ".concat((contact_module_default()).contact),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumbs["default"], {
        heading: formatMessage({
          id: "contact-us"
        }),
        description: "".concat(formatMessage({
          id: "main"
        }), " / ").concat(formatMessage({
          id: "contact-us"
        })),
        background: contactData === null || contactData === void 0 ? void 0 : contactData.breadCurmbImage
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "contact-header unique-bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "communicate"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "contact-page-top wrapper",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "contact-row-wrapper p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Row/* default */.Z, {
              className: "contact-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: "12",
                md: "6",
                className: "align-self-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Form/* default */.Z, {
                  formTitle: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "service_question"
                  }),
                  formSubtitle: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "service_ask"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                xs: "12",
                md: "6",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "contact-page-map",
                  "data-aos": "fade-up",
                  "data-aos-duration": "300",
                  "data-aos-delay": "400",
                  dangerouslySetInnerHTML: {
                    __html: (_initData$siteInfo$ma = initData === null || initData === void 0 ? void 0 : (_initData$siteInfo = initData.siteInfo) === null || _initData$siteInfo === void 0 ? void 0 : _initData$siteInfo.mapframe) !== null && _initData$siteInfo$ma !== void 0 ? _initData$siteInfo$ma : ""
                  }
                })
              })]
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Home_ContactNumbers, {
        initData: initData
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Row/* default */.Z, {
        className: "contact-info",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Footer.ContactsElements, {
          initdata: initData,
          locale: locale
        })
      })]
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ var contact_us = (ContactPage);

/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(682);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6896);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);







var BreadCrumb = function BreadCrumb(_ref) {
  var _heading$locale, _description$locale;

  var heading = _ref.heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "" : _ref$description;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      locale = _useIntl.locale;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      pathname = _useRouter.pathname;

  var shouldHidePath = pathname.startsWith("/blogs/") && pathname !== "/blogs";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "breads wrapper",
    style: {
      backgroundColor: "rgb(112 96 166 / 100%)"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "inner",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h1", {
          className: "unique-bold h3",
          children: (_heading$locale = heading === null || heading === void 0 ? void 0 : heading[locale]) !== null && _heading$locale !== void 0 ? _heading$locale : heading
        }), ((description === null || description === void 0 ? void 0 : description[locale]) || (description === null || description === void 0 ? void 0 : description.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
          children: !shouldHidePath && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            children: (_description$locale = description === null || description === void 0 ? void 0 : description[locale]) !== null && _description$locale !== void 0 ? _description$locale : description
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);

/***/ }),

/***/ 472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7794);
/* harmony import */ var _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7536);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4012);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1555);
/* harmony import */ var _src_assets_images_svg_arrow_big_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9492);
/* harmony import */ var _src_api_server__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5981);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6455);
/* harmony import */ var sweetalert2__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(sweetalert2__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var Form = function Form() {
  var _errors$Name, _errors$phone, _errors$email;

  var _useIntl = (0,react_intl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      systems = _useState[0],
      setSystems = _useState[1];

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_9__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      errors = _useForm.formState.errors;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
      var systemsResponse, sectionData;
      return _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _src_api_server__WEBPACK_IMPORTED_MODULE_5__/* ["default"].get */ .Z.get("/pages/systems");

            case 2:
              systemsResponse = _context.sent;

              sectionData = function sectionData(r) {
                var _r$data, _r$data$data, _r$data$data$page;

                return (r === null || r === void 0 ? void 0 : (_r$data = r.data) === null || _r$data === void 0 ? void 0 : (_r$data$data = _r$data.data) === null || _r$data$data === void 0 ? void 0 : (_r$data$data$page = _r$data$data.page) === null || _r$data$data$page === void 0 ? void 0 : _r$data$data$page.sections) || [];
              };

              setSystems(sectionData(systemsResponse));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2(data) {
      return _home_alnjoom_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _src_api_server__WEBPACK_IMPORTED_MODULE_5__/* ["default"].post */ .Z.post("/pages/contact/sections", {
                section: _objectSpread(_objectSpread({}, data), {}, {
                  title: data.name
                })
              });

            case 3:
              reset();
              sweetalert2__WEBPACK_IMPORTED_MODULE_6___default().fire("".concat(formatMessage({
                id: "thanks"
              })), "".concat(formatMessage({
                id: "thankMsg"
              })), "success");
              _context2.next = 10;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return");

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 7]]);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "order-form",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            className: "p-0",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "form-group",
              "data-aos": "fade-up",
              "data-aos-duration": "300",
              "data-aos-delay": "100",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
                htmlFor: "name",
                children: formatMessage({
                  id: "name"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread({
                id: "name",
                className: "form-control border"
              }, register("name", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$Name = errors.Name) === null || _errors$Name === void 0 ? void 0 : _errors$Name.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                  id: "requiredFields"
                })
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "form-group",
              "data-aos": "fade-up",
              "data-aos-duration": "300",
              "data-aos-delay": "200",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
                htmlFor: "phone",
                children: formatMessage({
                  id: "phone"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("input", _objectSpread({
                id: "phone",
                type: "text",
                className: "form-control border"
              }, register("phone", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$phone = errors.phone) === null || _errors$phone === void 0 ? void 0 : _errors$phone.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                  id: "requiredFields"
                })
              })]
            })]
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            className: "p-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
              className: "form-group",
              "data-aos": "fade-up",
              "data-aos-duration": "300",
              "data-aos-delay": "400",
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("label", {
                htmlFor: "message",
                children: formatMessage({
                  id: "details"
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("textarea", _objectSpread({
                id: "message",
                className: "form-control border"
              }, register("message", {
                required: true
              }))), (errors === null || errors === void 0 ? void 0 : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.type) === "required" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
                className: "error-hint",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                  id: "requiredFields"
                })
              })]
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: "form-group button",
          "data-aos": "fade-up",
          "data-aos-duration": "300",
          "data-aos-delay": "500",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
            type: "submit",
            className: "btn gradient-btn",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              id: "send"
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Form);

/***/ }),

/***/ 6543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(540);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5893);





var Seo = function Seo(_ref) {
  var title = _ref.title,
      description = _ref.description,
      keywords = _ref.keywords,
      _ref$noindex = _ref.noindex,
      noindex = _ref$noindex === void 0 ? false : _ref$noindex;

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      asPath = _useRouter.asPath,
      locale = _useRouter.locale;

  var _buildSeoAlternates = (0,_src_components_helpers_seo__WEBPACK_IMPORTED_MODULE_3__/* .buildSeoAlternates */ .Rl)(asPath, locale),
      canonical = _buildSeoAlternates.canonical,
      languageAlternates = _buildSeoAlternates.languageAlternates;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_0__/* .NextSeo */ .PB, {
    title: title,
    description: description,
    defaultTitle: title,
    noindex: noindex,
    nofollow: noindex,
    canonical: canonical,
    languageAlternates: languageAlternates,
    additionalMetaTags: [{
      name: "keywords",
      content: keywords
    }]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Seo);

/***/ }),

/***/ 540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rl": function() { return /* binding */ buildSeoAlternates; }
/* harmony export */ });
/* unused harmony exports SITE_URL, DEFAULT_LOCALE, localizedUrl */
// ====== إعدادات الـ SEO المشتركة ======
var SITE_URL = "https://alnjoom.sa";
var DEFAULT_LOCALE = "ar"; // النسخة الافتراضية (x-default) هي العربية
// ينظّف الـ path: يشيل الـ query/hash ويضبط الـ trailing slash

var normalizePath = function normalizePath() {
  var asPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var path = String(asPath).split("?")[0].split("#")[0] || "/";
  if (!path.startsWith("/")) path = "/".concat(path); // مطابقة لإعداد trailingSlash: true في next.config.js

  if (path !== "/" && !path.endsWith("/")) path = "".concat(path, "/");
  return path;
}; // يبني رابط مطلق للّغة المطلوبة (العربية بدون بادئة، الإنجليزية ببادئة /en)


var localizedUrl = function localizedUrl(asPath, locale) {
  var path = normalizePath(asPath); // يبدأ بـ "/" وينتهي بـ "/"

  if (locale === DEFAULT_LOCALE) return "".concat(SITE_URL).concat(path);
  return path === "/" ? "".concat(SITE_URL, "/").concat(locale, "/") : "".concat(SITE_URL, "/").concat(locale).concat(path);
}; // يبني canonical + hreflang (ar / en / x-default) لأي صفحة
// x-default يشير دائمًا للنسخة العربية

var buildSeoAlternates = function buildSeoAlternates(asPath) {
  var currentLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_LOCALE;
  return {
    canonical: localizedUrl(asPath, currentLocale),
    languageAlternates: [{
      hrefLang: "ar",
      href: localizedUrl(asPath, "ar")
    }, {
      hrefLang: "en",
      href: localizedUrl(asPath, "en")
    }, {
      hrefLang: "x-default",
      href: localizedUrl(asPath, DEFAULT_LOCALE)
    }]
  };
};

/***/ }),

/***/ 6008:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(9254);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9492:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/arrow-big.e723219e.svg","height":16,"width":18});

/***/ }),

/***/ 9256:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact-nums":"style_contact-nums__ZB9VS"};

/***/ }),

/***/ 451:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact_contact___aHw6","gradient_in":"contact_gradient_in__hWSdp","gradient_out":"contact_gradient_out__OA75o","gradient_opacity_out":"contact_gradient_opacity_out___ZqSU","gradient_opacity_in":"contact_gradient_opacity_in__JKerv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8166,2962,2143,1664,3053,296,9774,2888,179], function() { return __webpack_exec__(6008); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);